<template>
  <div class="el-section">
    <dash-fees-list></dash-fees-list>
  </div>
</template>

<script>
import '@pagarme/fees-list/web-comp'

export default {
  name: 'fees'
}
</script>
